//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { memo, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { exitCoverOrder } from "../../apis";
import { getAllOrders, updateExitOrderData } from "../../redux/actions/orders";
import { API_RESPONSE_STATUS, MARKET_SEGMENT_ID, ORDER_PRODUCT_TYPES, ORDER_STATUS_FROM_RESPONSE, ORDER_TYPES, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY } from "../../utils/global_variables";
import { convertPosition, convertPositionFailure } from "../../redux/actions/netPosition";


const ExitOrderModal = ({ ordersTabKey }) => {
    const dispatch = useDispatch();
    const { objExitOrderData, modalType } = useSelector(state => state.orders?.objExitOrderData);

    const handleClose = () => {
        dispatch(handleModal([{ "EXIT_OR_CONVERT_POSITION_ORDER_MODAL": false }]));
        dispatch(updateExitOrderData({}));
        dispatch(convertPositionFailure({}));
    };
    const modals = useSelector(state => state.modals?.modals);

    const handleExitOrder = async () => {
        let coverExitprice = 0;
        let buyPrice = 0;
        let sellPrice = 0;
        let MPClosePrice = 0;

        MPClosePrice = !objExitOrderData?.closePrice ? 0 : parseFloat(objExitOrderData?.closePrice);
        buyPrice = (!objExitOrderData?.buyPrice || objExitOrderData?.buyPrice == "-") ? 0 : parseFloat(objExitOrderData?.buyPrice);
        sellPrice = (!objExitOrderData?.sellPrice || objExitOrderData?.sellPrice == "-") ? 0 : parseFloat(objExitOrderData?.sellPrice);
        let ltp = (objExitOrderData?.ltp) ? parseFloat(objExitOrderData?.ltp) : 0;
        if (objExitOrderData?.type == 'BUY') {
            coverExitprice = ltp || buyPrice || sellPrice;
            if (ltp && buyPrice) {
                coverExitprice = Math.min(ltp, buyPrice);
            }
            if (coverExitprice && sellPrice) {
                coverExitprice = Math.min(coverExitprice, sellPrice);
            }
        }
        else {
            let dblPrice1 = Math.max(sellPrice, ((objExitOrderData.ltp) ? parseFloat(objExitOrderData.ltp) : 0));
            let dblPrice2 = Math.max(dblPrice1, buyPrice);
            coverExitprice = dblPrice2;
        }
        if (parseInt(coverExitprice) == 0) {
            coverExitprice = MPClosePrice;
        }
        let orderid = objExitOrderData?.orderNo;
        if (objExitOrderData?.prodType === ORDER_PRODUCT_TYPES.BRACKET && objExitOrderData?.bracket_details?.leg_indicator !== "Main Leg") {
            orderid = objExitOrderData?.bracket_details?.parent_order_id;
        }
        const orderType = objExitOrderData?.prodType === ORDER_PRODUCT_TYPES.BRACKET ? 'bracket' : 'cover';
        const objResp = await exitCoverOrder(objExitOrderData?.exchangeSegment, orderid, coverExitprice, orderType);
        if (objResp?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
            dispatch(handleModal([{ 'EXIT_OR_CONVERT_POSITION_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
            dispatch(handleModalData({ data: { isExit: true, orderEntryTab: ORDER_TYPES.SINGLE_SCRIP, objScripData: objExitOrderData } }));
            setTimeout(() => {
                if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                }
                dispatch(handleModal([{ "ORDER_STATUS": false }]));
            }, 3000);
        }
    };

    const displayProductType = useMemo(() => {
        if (objExitOrderData?.mktId === MARKET_SEGMENT_ID.NSE_CASH || objExitOrderData?.mktId === MARKET_SEGMENT_ID.BSE_CASH || objExitOrderData?.mktId === MARKET_SEGMENT_ID.MSX_CASH) {

            return ORDER_PRODUCT_TYPES.DELIVERY;
        } else {
            return ORDER_PRODUCT_TYPES.CARRYFORWARD;

        }

    }, [objExitOrderData]);

    const conversionQuantity = useMemo(() => {
        let qty = objExitOrderData?.traded_quantity;
        if (objExitOrderData['Profit Leg']?.status && (objExitOrderData['Profit Leg']?.status).toUpperCase() !== ORDER_STATUS_FROM_RESPONSE.CANCELLED) {
            qty = objExitOrderData['Profit Leg']?.pending_quantity;
        }
        if (objExitOrderData['Stop Loss Leg']?.status && (objExitOrderData['Stop Loss Leg']?.status).toUpperCase() !== ORDER_STATUS_FROM_RESPONSE.CANCELLED) {
            qty = objExitOrderData['Stop Loss Leg']?.pending_quantity;
        }
        if (objExitOrderData['Exit Leg']?.status && (objExitOrderData['Exit Leg']?.status).toUpperCase() !== ORDER_STATUS_FROM_RESPONSE.CANCELLED) {
            qty = objExitOrderData['Exit Leg']?.pending_quantity;
        }



        return qty;
    }, [objExitOrderData]);

    const objConvertPosition = useSelector(state => state?.netPosition?.objConvertPosition);

    const handleConvertPosition = () => {

        dispatch(convertPosition(objExitOrderData?.exchangeSegment, objExitOrderData?.scrip_token, objExitOrderData?.type, conversionQuantity, ORDER_PRODUCT_TYPES.BRACKET, ORDER_PRODUCT_TYPES.DELIVERY, [], '', {}, [], objExitOrderData?.order_id, objExitOrderData?.bracket_details?.bo_gatewayorderno, objExitOrderData?.bracket_details.leg_indicator))?.then((res) => {
            if (res?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
                dispatch(handleModal([{ 'EXIT_OR_CONVERT_POSITION_ORDER_MODAL': false }, { 'ORDER_STATUS': true }], true));
                dispatch(handleModalData({ data: { isConvertOrderPosition: true, orderEntryTab: ORDER_TYPES.SINGLE_SCRIP, objScripData: { ...objExitOrderData, conversionQuantity: conversionQuantity, newConversionProdType: displayProductType } } }));
                setTimeout(() => {
                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                    } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                    }
                    dispatch(handleModal([{ "ORDER_STATUS": false }]));
                }, 3000);
            }

        });

    };
    return (
        <BzModal className='modal-breeze' show={modals['EXIT_OR_CONVERT_POSITION_ORDER_MODAL']} onHide={handleClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>{modalType === 'exit' ? 'Exit Order' : 'Convert Position'}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 pb-2 mb-2'>
                        <Col>
                            {modalType === 'exit' ?
                                <div className='font-regular font-size4 color-text'>Are you sure you want to exit the order?</div> :
                                <div className='font-regular font-size4 color-text'>Are you sure you want to cancel the pending orders and convert the open position of {conversionQuantity} qty to {displayProductType}?</div>}

                        </Col>
                    </Row>
                    {
                        objConvertPosition?.status === API_RESPONSE_STATUS.ERROR &&
                        <Row className='g-0 py-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='error-msg text-wrap'>{objConvertPosition?.message}</div>
                            </Col>
                        </Row>
                    }
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-end'>
                            <BzButton className='btn btn-md btn-outline text-uppercase me-2' onClick={handleClose}>CLOSE</BzButton>
                            <BzButton className='btn btn-md btn-primary text-uppercase ms-2' onClick={modalType === 'exit' ? handleExitOrder : handleConvertPosition}>Confirm</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
        // <OrderStatus />  
    );
};
export default memo(ExitOrderModal);
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End
